export default __webpack_public_path__ + "static/1-8dd13adc63e130f2ede7ea9161c73c8d.mp4";